<template>
    <div>
        <v-dialog
            :open="value"
            class="admin-person-info-add-tel-dialog"
            title="添加管理员登录手机"
            kind="confirm"
            @input="onInput"
        >
            <div slot="subtitle">绑定后可使用短信验证码快捷登录企点</div>
            <v-form ref="form" :model="form" @submit.prevent="handleSubmit">
                <v-form-item :rules="formRules.tel" label="手机号" name="tel" error-placement="top-right">
                    <v-input v-model="form.tel" kind="simple"></v-input>
                </v-form-item>
                <v-form-item
                    :error="captchaErrorInfo"
                    class="captcha-form-item"
                    label="验证码"
                    name="captcha"
                    error-placement="top-right"
                    @error="onCaptchaError"
                >
                    <v-input v-model="form.captcha" class="captcha-input" kind="simple"></v-input>
                    <v-button v-show="isCountdown" status="default" disabled style="width:102px"
                        >{{ countdown }}s</v-button
                    >
                    <v-button v-show="!isCountdown" status="default" style="width:102px" @click="handleGetCaptcha"
                        >获取验证码</v-button
                    >
                </v-form-item>
            </v-form>
            <span slot="footer">
                <v-button status="primary" size="large" :loading="bindTelLoading" @click="handleBindTel(true)"
                    >绑定手机</v-button
                >
            </span>
        </v-dialog>
        <bind-confirm-dialog
            :show.sync="bindTelConfirmDialogVisiable"
            :has-bind-tel-count="hasBindTelCount"
            @on-confirm="handleConfirmBindTel"
        />
        <bind-tip-dialog :show.sync="bindTelTipDialogVisiable" />
    </div>
</template>

<script>
import BindTelMixin from '../mixins/bind-tel-mixin';

export default {
    mixins: [BindTelMixin]
};
</script>

<style lang="less">
.admin-person-info-add-tel-dialog {
    .v-dialog__container {
        width: 440px;
    }
    .v-dialog__content {
        padding: 45px 40px;
    }
    .v-form-item__label,
    .v-form-item__input {
        display: inline-block;
        float: none;
    }
    .v-form-item__label {
        width: 50px;
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #1e2330;
        margin: 0;
        text-align: left;
        transform: translateY(-16px);
        label {
            margin: 0;
        }
    }
    .v-input {
        width: 302px;
        .v-input--simple__input {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 22px;
            color: #1e2330;
        }
    }
    .captcha-input {
        width: 186px;
    }
    .v-dialog__body {
        margin-top: 40px;
    }
    .captcha-form-item {
        .v-form-item__input {
            text-align: justify;
            width: 302px;
            .v-button {
                float: right;
            }
            .v-form-item__trerr {
                transform: translateX(-112px);
            }
        }
    }
}
</style>
